<template>
  <div>
    <!-- Affichage d'une barre de progression pendant le chargement des données -->
    <load-progress :condition="!dataLoaded" label="Chargement des données"></load-progress>
    <!-- Affichage du tree view et des éditeurs selon l'objet sélectionné -->

    <div v-if="dataLoaded" class="p-0 module-container">
      <v-row class="m-0">
          <v-col cols="12" style="background-color: white;">
            <div class="titre-module pt-0 mb-1" v-html="titleHtml"></div>
          </v-col>
          <v-col cols="12" class="p-0">
            <list-notifications :notifications="notifList"></list-notifications>
          </v-col>
      </v-row>
    </div>
  </div>
</template>

<script lang="ts">
import LoadProgress from '@/framework/base/components/LoadProgress.vue';
import Notif from '@/generated/classes/Notif';
import { storeNotif } from '@/generated/stores';
import { RouteBuilder } from '@/generated/router/RouteBuilder';
import ModuleBase from '@/framework/base/components/ModuleBase';
import ListNotifications from '@/framework/notif/components/ListNotifications.vue';
import { ObjTypes } from '@/generated/classes/ObjTypes';
import { ListFilter } from '@/extend/classes/ListData';
import { RouteElements } from '@/framework/base/classes/Section';
import Route from '@/generated/classes/Route';
import { defineComponent } from "vue";

export function ModuleNotificationOpenFiche(route: Route): RouteElements {
  return new RouteElements();
}

export default defineComponent({
  components: {
    LoadProgress,
    ListNotifications
  },
  extends: ModuleBase,
  created(): void {
    // Load and register events on used server classes
    const allData = new ListFilter();
    allData.pageLimit = -1;
    storeNotif.registerNotif();
    storeNotif.listFilteredNotif(allData);
  },
  computed: {
    titleHtml(): string {
      // let res = '';
      // if (this.ressource.label) {
      //   const title = this.ressource.label.split(" ");
      //   res = title[0] + " <span style='color:#E42724;'>" + title [1] + '</span>';
      // }
      return 'Notifications';
    },
    dataLoaded(): boolean {
      const res = storeNotif.notifLoaded;
      return res;
    },
    notifList(): Notif[] {
      const notifs = storeNotif.listNotif;
      const notifList: Notif[] = [];
      notifs.forEach((notif) => {
        if (notif.ownerType != ObjTypes.ADMIN) {
          notifList.push(notif);
          RouteBuilder.loadStore(notif.route);
        }
      })
      return notifList;
    }
  },

  methods: {

  }
})

</script>

<style scoped>
.module-container {
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 10px;
}

.module-title {
    font-size: 24px;
    font-weight: bold;
    background-color: white;
    border-radius: 10px 10px 0 0;
}
</style>
